import { render, staticRenderFns } from "./JobCharges.vue?vue&type=template&id=186d05dd&scoped=true&"
import script from "./JobCharges.vue?vue&type=script&lang=js&"
export * from "./JobCharges.vue?vue&type=script&lang=js&"
import style0 from "./JobCharges.vue?vue&type=style&index=0&id=186d05dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186d05dd",
  null
  
)

export default component.exports